module.exports = __webpack_public_path__ + "static/media/microsoftLogo.295028e0.svg";